var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2057_657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.69147 0 0 2.69147 0 6C0 9.30853 2.69147 12 6 12C9.30853 12 12 9.30853 12 6C12 2.69147 9.30853 0 6 0Z",
    fill: "#C62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20947 7.50246C8.40493 7.69802 8.40493 8.01397 8.20947 8.20953C8.11196 8.30703 7.98397 8.35601 7.85589 8.35601C7.7279 8.35601 7.59991 8.30703 7.5024 8.20953L5.99993 6.70696L4.49746 8.20953C4.39996 8.30703 4.27197 8.35601 4.14397 8.35601C4.01589 8.35601 3.8879 8.30703 3.7904 8.20953C3.59493 8.01397 3.59493 7.69802 3.7904 7.50246L5.29296 5.99999L3.7904 4.49752C3.59493 4.30196 3.59493 3.98602 3.7904 3.79046C3.98595 3.59499 4.3019 3.59499 4.49746 3.79046L5.99993 5.29302L7.5024 3.79046C7.69796 3.59499 8.01391 3.59499 8.20947 3.79046C8.40493 3.98602 8.40493 4.30196 8.20947 4.49752L6.7069 5.99999L8.20947 7.50246Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2057_657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove2);
export default __webpack_public_path__ + "static/media/remove2.50644c9cf9e73f1b75a1556e66710c34.svg";
export { ForwardRef as ReactComponent };